<div class="dialog-content-container">
  <div class="dialog-header">
    <h3 class="dialog-title">Reautenticación</h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text">
      {{ type === 'enroll' ? ' Ingrese su contraseña para continuar con la
      autenticación por dos factores' : 'Ingrese su contraseña para continuar
      con la desactivación de la autenticación por dos factores' }}
    </p>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
      <div class="field mb-3">
        <input
          type="email"
          formControlName="email"
          placeholder="correo@excuela.com"
          autocomplete="email"
          name="email"
          class="form-input"
        />
      </div>
      <div class="form-field">
        <div class="password-input">
          <input
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            placeholder="••••••••"
            autocomplete="password"
            name="password"
            class="form-input"
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility()"
          >
            <i
              class="fas"
              [class.fa-eye]="hidePassword"
              [class.fa-eye-slash]="!hidePassword"
            ></i>
          </button>
        </div>
        <div
          *appFormFieldError="form.get('password'); let errors"
          class="error-message-small"
        >
          @for (error of errors; track error) {
          <div>{{ error }}</div>
          }
        </div>
      </div>
      <button
        pButton
        type="submit"
        class="p-button-primary w-full mt-3 text-sm"
        [disabled]="form.invalid || submitting"
      >
        @if (submitting) {
        <div class="loader-container">
          <div class="spinner"></div>
          <span>Autenticando...</span>
        </div>
        } @else { {{ type === 'enroll' ? 'Autenticar y generar código QR' :
        'Autenticar' }} }
      </button>
    </form>
  </div>
</div>
